/* Varme Sticky Cart + cart-drawer glue — self-contained, no build step.
   1) Sticky bar: reads product/variant data from the DOM (rendered by
      sections/varme-sticky-cart.liquid), appears once the main add-to-cart
      button scrolls out of view. Variant picker is one group per product
      option (.vsc-opt-group[data-pos]) containing either image swatches
      (.vsc-sw) or text pills (.vsc-pill) — mirrors the main PDP so it works
      for any number of options, not just single-option products.
   2) Main add-to-cart (Varme PDP section uses a plain {% form 'product' %}):
      intercepted here so it adds via AJAX and slides the theme's cart drawer
      in from the right — same behaviour as the theme's native product form.
   Theme internals used (Horizon family): <cart-drawer-component>.open(),
   'cart:update' event with detail.data.sections for section morphing. */
(function () {

  /* ---------- shared cart helpers (theme drawer integration) ---------- */

  function cartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset && el.dataset.sectionId) ids.push(el.dataset.sectionId);
    });
    return ids;
  }

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return false;
    try {
      if (typeof drawer.open === 'function') { drawer.open(); return true; }
      if (typeof drawer.showDialog === 'function') { drawer.showDialog(); return true; }
    } catch (e) {}
    return false;
  }

  // Mirrors the theme's own CartAddEvent so the drawer contents, cart icon
  // bubble and any other listeners update exactly like a native add-to-cart.
  function dispatchCartUpdate(cart, sections, qty, productId) {
    var ev = new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart || {},
        sourceId: 'varme-cart',
        data: {
          source: 'product-form-component',
          itemCount: qty,
          productId: productId,
          sections: sections || {}
        }
      }
    });
    document.dispatchEvent(ev);
  }

  // POST to /cart/add.js (with drawer section HTML in the response), then
  // refresh the theme UI and slide the drawer open. Returns a promise.
  function addToCartAndOpen(body, qty, productId) {
    var isForm = (typeof FormData !== 'undefined') && body instanceof FormData;
    var ids = cartSectionIds();
    if (isForm) {
      if (ids.length) body.set('sections', ids.join(','));
    } else {
      if (ids.length) body.sections = ids.join(',');
      body = JSON.stringify(body);
    }
    var opts = {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: body
    };
    if (!isForm) opts.headers['Content-Type'] = 'application/json';

    return fetch('/cart/add.js', opts)
      .then(function (r) {
        if (!r.ok) throw new Error('cart/add ' + r.status);
        return r.json();
      })
      .then(function (added) {
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; })
          .then(function (cart) {
            dispatchCartUpdate(cart, added && added.sections, qty, productId);
            openCartDrawer();
            return added;
          });
      });
  }

  /* ---------- main add-to-cart form (Varme PDP section) ---------- */

  document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
    if (form.closest('.vsc-bar')) return;                    // sticky bar handles itself
    if (form.closest('product-form-component')) return;      // theme form handles itself
    if (form.dataset.varmeAjax === 'true') return;
    form.dataset.varmeAjax = 'true';

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn && btn.disabled) return;
      var fd = new FormData(form);
      var qty = Math.max(1, parseInt(fd.get('quantity'), 10) || 1);
      var original = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }

      addToCartAndOpen(fd, qty, null)
        .then(function () {
          if (btn) btn.textContent = 'Added ✓';
        })
        .catch(function () {
          // fall back to the regular page flow rather than failing silently
          // (form.submit() bypasses submit listeners, so this won't loop)
          if (btn) { btn.textContent = original; btn.disabled = false; }
          form.submit();
        })
        .finally(function () {
          setTimeout(function () {
            if (btn) { btn.textContent = original; btn.disabled = false; }
          }, 1600);
        });
    });
  });

  /* ---------- sticky bar ---------- */

  var bar = document.querySelector('.vsc-bar');
  if (!bar) return;

  // Move the bar to <body> so position:fixed is relative to the viewport. Shopify
  // section wrappers / this theme's view-transitions apply a transform on an ancestor,
  // which otherwise traps a fixed element and makes it scroll with the page.
  if (bar.parentElement !== document.body) document.body.appendChild(bar);

  var priceEl  = bar.querySelector('.vsc-price');
  var vtitle   = bar.querySelector('.vsc-vtitle');
  var imgEl    = bar.querySelector('.vsc-img');
  var qtyEl    = bar.querySelector('.vsc-qty-input');
  var addBtn   = bar.querySelector('.vsc-add');
  var currentId = bar.getAttribute('data-variant-id');

  // vmap: [{id, title, price, available, img, opts:[opt1,opt2,opt3]}], keyed by
  // product id and inlined by the liquid template just above this script tag.
  var vmapAll = window.__vscVariantMap || {};
  var vmapKeys = Object.keys(vmapAll);
  var vmap = vmapKeys.length ? vmapAll[vmapKeys[vmapKeys.length - 1]] : [];

  // Current selection per option position, seeded from each group's initial
  // is-active button (server-rendered to match the current variant).
  var groups = Array.prototype.slice.call(bar.querySelectorAll('.vsc-opt-group'));
  var selOpts = groups.map(function (g) {
    var active = g.querySelector('.is-active');
    return active ? active.getAttribute('data-val') : null;
  });

  function findVariant() {
    if (!vmap.length) return null;
    return vmap.find(function (v) {
      return selOpts.every(function (val, i) { return val == null || v.opts[i] === val; });
    });
  }

  function applyVariant(v) {
    if (!v) return;
    currentId = String(v.id);
    if (priceEl) priceEl.textContent = v.price;
    if (vtitle) vtitle.textContent = v.title;
    if (imgEl && v.img) imgEl.src = v.img;
    if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? 'Add to cart' : 'Sold out'; }
  }

  // Swatch / pill clicks: update this option's selection, mark active state
  // within its own group only, resolve the matching variant, apply it.
  bar.querySelectorAll('.vsc-sw[data-pos], .vsc-pill[data-pos]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      var pos = parseInt(btn.getAttribute('data-pos'), 10);
      selOpts[pos] = btn.getAttribute('data-val');
      var group = btn.closest('.vsc-opt-group');
      if (group) {
        group.querySelectorAll('.vsc-sw, .vsc-pill').forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
      }
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');
      applyVariant(findVariant());
    });
  });

  // Quantity stepper.
  bar.querySelectorAll('.vsc-qbtn').forEach(function (b) {
    b.addEventListener('click', function () {
      var n = parseInt(qtyEl.value, 10) || 1;
      qtyEl.value = Math.max(1, n + parseInt(b.getAttribute('data-step'), 10));
    });
  });

  // Stay in sync with the theme's main product form. The Varme product section
  // dispatches a `variant:change` event whenever a swatch/pill is clicked there;
  // mirror the chosen variant here (matching each group's buttons by value) so
  // the bar always adds the correct one — important since the picker can be
  // hidden or partially hidden depending on viewport.
  document.addEventListener('variant:change', function (e) {
    var v = e && e.detail && e.detail.variant;
    if (!v || !v.opts) return;

    selOpts = v.opts.slice(0, groups.length);
    groups.forEach(function (g, pos) {
      g.querySelectorAll('.vsc-sw, .vsc-pill').forEach(function (b) {
        var match = b.getAttribute('data-val') === selOpts[pos];
        b.classList.toggle('is-active', match);
        b.setAttribute('aria-pressed', match ? 'true' : 'false');
      });
    });
    applyVariant(v);
  });

  // Add to cart (AJAX, no page reload) — opens the theme's cart drawer.
  if (addBtn) {
    addBtn.addEventListener('click', function () {
      if (addBtn.disabled) return;
      var qty = Math.max(1, parseInt(qtyEl ? qtyEl.value : 1, 10) || 1);
      var original = addBtn.textContent;
      addBtn.textContent = 'Adding...';
      addBtn.disabled = true;
      addToCartAndOpen({ items: [{ id: parseInt(currentId, 10), quantity: qty }] }, qty, null)
        .then(function () {
          addBtn.textContent = 'Added';
          setTimeout(function () { addBtn.textContent = original; addBtn.disabled = false; }, 1600);
        })
        .catch(function () { window.location.href = '/cart'; });
    });
  }

  // Reveal on scroll — hidden while the main product buy button is visible.
  var anchorSel = (bar.getAttribute('data-anchor') || '').trim() ||
    'product-form, .product-form__buttons, form[action*="/cart/add"] [type="submit"], .shopify-payment-button';
  var anchor = document.querySelector(anchorSel);

  if (anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting && e.boundingClientRect.top < 0) bar.classList.add('show');
        else bar.classList.remove('show');
      });
    }, { threshold: 0 }).observe(anchor);
  } else {
    var onScroll = function () {
      if (window.pageYOffset > 480) bar.classList.add('show');
      else bar.classList.remove('show');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();
